// Which time zone a customer is in, the same way the server decides it (DESIGN §5 step 2):
// the contact's own zone, else the area code, else the workspace's.

import { timezonesForAreaCode } from '@bt/core';

export type TzSource = 'contact' | 'area_code' | 'workspace';

export function effectiveTimezone(
  contact: { timezone?: string | null; phone_number: string } | null | undefined,
  workspaceTz: string,
): { tz: string; source: TzSource; candidates: string[] } {
  if (contact?.timezone) return { tz: contact.timezone, source: 'contact', candidates: [contact.timezone] };
  const zones = contact ? timezonesForAreaCode(contact.phone_number) : [];
  if (zones.length > 0) return { tz: zones[0], source: 'area_code', candidates: zones };
  return { tz: workspaceTz, source: 'workspace', candidates: [workspaceTz] };
}

export const TZ_SOURCE_WORDS: Record<TzSource, string> = {
  contact: 'set on the contact',
  area_code: 'from the area code',
  workspace: 'office default',
};

/** A short list for the timezone <select>s. The office can type any IANA id too. */
export const COMMON_TIMEZONES: { id: string; label: string }[] = [
  { id: 'America/New_York', label: 'Eastern (New York)' },
  { id: 'America/Chicago', label: 'Central (Chicago)' },
  { id: 'America/Denver', label: 'Mountain (Denver)' },
  { id: 'America/Phoenix', label: 'Arizona (Phoenix)' },
  { id: 'America/Los_Angeles', label: 'Pacific (Los Angeles)' },
  { id: 'America/Anchorage', label: 'Alaska' },
  { id: 'Pacific/Honolulu', label: 'Hawaii' },
  { id: 'America/Puerto_Rico', label: 'Atlantic (Puerto Rico)' },
];
